'use strict'

export const UPDATE_EVENTS_JSON_LOADED = 'UPDATE_EVENTS_JSON_LOADED'
export const UPDATE_EVENTS_JSON = 'UPDATE_EVENTS_JSON'
